import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  modal: {
    width: "50vw",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    padding: "3%",
  },
  text: {
    textAlign: "center",
    paddingBottom: "3%",
    fontSize: "$h3",
  },
});
